import {gql, useLazyQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getResortLocationArrival($hapimagResortId: Int!, $locale: String!){
   resortCollection(limit: 1, where: { hapimagResortId: $hapimagResortId }, locale: $locale) {
    items {
      resortFacilitiesAmenities {
        title
        wellness
        internet
        pool
        restaurant
        smallKiosk
        kidsClub
        generalComfortCollection {
          items {
            text
            available
          }
        }
        sportEntertainmentCollection {
          items {
            text
            available
          }
        }
        kidsTeenCollection {
          items {
            text
            available
          }
        }
        wellnessCareCollection {
          items {
            text
            available
          }
        }
        leisureRentalServicesCollection {
          items {
            text
            available
          }
        }
        languagesCollection {
          items {
            text
            available
          }
        }
        foodMealCollection {
          items {
            text
            available
          }
        }
        resortMap {
            url
        }
      }
    }
  }
}`;

export const useResortFacilities = () => {
    const {logger} = useLogger();
    const [getResortFacilities, { loading, data, error }] = useLazyQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const facilities = data?.resortCollection?.items[0]?.resortFacilitiesAmenities;

    if (error?.message) {
        logger(error?.message, "error", "useResortFacilities", error?.stack);
    }

    return {
        facilities,
        getResortFacilities,
        resortFacilitiesLoading: loading
    };
};
